import { Column, Entity, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";

@Entity('holidays_calendar')
export class HolidaysCalendar {

    @PrimaryGeneratedColumn("increment", {
        name: 'holiday_id'
    })
    holidayId: number;

    @Column("char", {
        nullable: false,
        length: 50,
        name: "holiday_name"
    })
    holidayName: string;

    @Column("varchar", {
        nullable: true,
        name: "holiday_date"
    })
    holidayDate: Date;

    // @Column("varchar", {
    //     nullable: true,
    //     name: "holiday_year"
    // })
    // holidayYear: Date;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        default: 1,
        name: "created_user"
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

}
